(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      // 2026-10-02: the whole sticky block (logo row + category bar, ~150px) as --ame-sticky-top on EVERY page —
      // until now only the PDP published it, so sticky sidebars and in-page anchors elsewhere used guessed offsets.
      // ResizeObserver follows the logo-shrink state; --header-height keeps Dawn's own (load / breakpoint) timing.
      this.setStickyTop();
      if ('ResizeObserver' in window) new ResizeObserver(this.setStickyTop.bind(this)).observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      // 2026-10-02: mirror the type-ahead's open state as a class on the header for the overflow rule in
      // ame-header.css — the :has() version alone leaves the dropdown clipped on browsers without :has().
      if (this.predictiveSearch && 'MutationObserver' in window) {
        var ps = this.predictiveSearch, hdr = this.querySelector('header.header') || this.header;
        var mirror = function () { hdr.classList.toggle('ame-psearch-open', ps.hasAttribute('open')); };
        new MutationObserver(mirror).observe(ps, { attributes: true, attributeFilter: ['open'] }); mirror();
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setStickyTop() {
      document.documentElement.style.setProperty('--ame-sticky-top', `${Math.round(this.header.getBoundingClientRect().height)}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {
    var hamburger = document.getElementById('hamburger');
    if (hamburger) {
      hamburger.addEventListener('click', function() {
        var menuHeader = document.querySelector('.header.menu-header');
        if (menuHeader) {
          if (menuHeader.classList.contains('scrolled-up')) {
            menuHeader.classList.remove('scrolled-up');
            menuHeader.classList.add('scrolled-down');
          } else if (menuHeader.classList.contains('scrolled-down')) {
            menuHeader.classList.remove('scrolled-down');
            menuHeader.classList.add('scrolled-up');
          }
        }
      });
    }

    var navscroll = document.getElementById('navscroll');
    if (navscroll) {
      var bannerHeight = navscroll.offsetHeight;
      var lastScrollTop = 0;
      window.addEventListener('scroll', function() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var banner = document.getElementById('banner');
        if (banner) {
          if (scrollTop >= bannerHeight && scrollTop > lastScrollTop) {
            banner.style.display = 'none';
          } else {
            banner.style.display = '';
          }
        }
        lastScrollTop = scrollTop;
      });
    }
  });


  } catch(e) { console.error(e); }
})();
})();
